export const TRIGGER_ID = 'jira-in-context-config-sidebar-changeboarding-trigger-id';
export const EVENT_ID = 'jira-in-context-config-sidebar-changeboarding-event-id';

export type MessageEventDetails = {
	action: 'dismiss' | 'showMe' | 'filter' | 'viewed' | 'snooze';
};
